import { serverResponse } from 'app'

import * as actions from '../../actions/verify'

export default (state = actions.getVerifyInitialState(), action = {}) => {
  switch (action.type) {
    case actions.VERIFY_FETCH: {
      return serverResponse(state, { loading: true })
    }
    case actions.VERIFY_FETCH_CANCELED: {
      return serverResponse(state)
    }
    case actions.VERIFY_FETCH_ERROR: {
      return serverResponse({ error: action.payload })
    }
    case actions.VERIFY_FETCH_FULFILLED: {
      return serverResponse(action.payload, {
        loaded: true,
      })
    }

    default:
  }
  return state
}
